import { Accounting } from '~/types/accounting';
export const accountingFullName = {
    [Accounting.QBO]: 'QuickBooks Online',
    [Accounting.Xero]: 'Xero'
};
